import { render, staticRenderFns } from "./payment_status.vue?vue&type=template&id=70c61cd1&scoped=true"
import script from "./payment_status.vue?vue&type=script&lang=js"
export * from "./payment_status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c61cd1",
  null
  
)

export default component.exports